// 1 = normal invoice  2 = Charge Back
export const AP_INVOICE_TYPES = [
  {
    label: 'Invoice',
    value: 1
  }, {
    label: 'Chargeback',
    value: 2
  }
];